import { zonedTimeToUtc } from "date-fns-tz";

const convertDateTimeToUtc = (date = null, tz = null) => {
  if (!date || !tz) return null;

  return zonedTimeToUtc(date, tz);
};

export default convertDateTimeToUtc;
